import { useTranslation } from "react-i18next";

const BookingCancellation = ({
  authDetailBooking,
  typo12,
}) => {
  const { t, i18n } = useTranslation();

  const deferredPayment = authDetailBooking?.user?.deferredPaymentEligible;
  const cancelRequestData = authDetailBooking?.requestChangeBooking?.find(request => request.requestType === "cancel");

  const cancellationFee = cancelRequestData?.cancellationFee || 0;
  const meetAssistFee = cancelRequestData?.meetAssistCancellationFee || { arrival: 0, departure: 0 };
  const totalCancellationFee = cancelRequestData?.totalCancellationFee || (cancellationFee + meetAssistFee.arrival + meetAssistFee.departure);
  const refundAmount = cancelRequestData?.refundAmount || 0;
  const chargeAmount = cancelRequestData?.chargeAmount || 0;
  const newBookingTotalPrice = cancelRequestData?.editBooking?.totalPrice || 0;
  const oldBookingTotalPrice = cancelRequestData?.bookingId?.totalPrice || 0;
  const isDeferredPayment = cancelRequestData?.userId?.deferredPaymentEligible;
  const travelDateChanged = cancelRequestData?.changesIdentification?.travelDate?.changed;
  const cancellationDesc = cancelRequestData?.cancellationDesc?.en || "-";
  const meetAssistDesc = cancelRequestData?.meetAssistCancellationDesc || { arrival: { en: "-" }, departure: { en: "-" } };

  const isHigherPrice = (cancellationFee + meetAssistFee.arrival + meetAssistFee.departure + newBookingTotalPrice) > oldBookingTotalPrice;

  function detectDowngradeMeetAssist() {
    const result = { arrival: false, departure: false };

    if (cancelRequestData?.meetAssistCancellationDesc?.arrival?.type !== "none") {
      result.arrival = true;
    }

    if (cancelRequestData?.meetAssistCancellationDesc?.departure?.type !== "none") {
      result.departure = true;
    }

    return result;
  }


  return (
    <div className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:lg:px-7 tw:py-[30px]">
      <div className="tw:font-hanken-grotesk tw:pb-6 tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-[#282828] tw:px-5 tw:lg:px-0">
        {t("bookingDetail.bookingCancellation.title")}
      </div>
      <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
      <div className="tw:flex tw:flex-col tw:gap-5 tw:lg:gap-[14px] tw:pt-6 tw:px-5 tw:lg:px-0">
        {
          (!deferredPayment && cancelRequestData?.refundAmount > 0) && (
            <>
              <div className="tw:flex tw:flex-col">
                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.bookingCancellation.refundAmount")}</span>
                <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                  {`${cancelRequestData?.refundAmount.toLocaleString()}${t("bookingDetail.bookingCancellation.jpy")}`}
                </p>
              </div>
              <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
            </>
          )
        }
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-y-[14px] tw:lg:gap-y-0 tw:gap-4">
          <>
            <div className="tw:lg:w-[200px]">
              <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.bookingCancellation.cancellationFee")}</span>
              <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                {`${cancelRequestData?.cancellationFee.toLocaleString()}${t("bookingDetail.bookingCancellation.jpy")}`}
              </div>
            </div>
            <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8] tw:block tw:lg:hidden" />
            <div className="">
              <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.bookingCancellation.cancellationRate")}</span>
              <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                {i18n.language === "jp" ? cancelRequestData?.cancellationDesc?.jp : cancelRequestData?.cancellationDesc?.en}
              </div>
            </div>
          </>
        </div>
        {
          (detectDowngradeMeetAssist().arrival) && (
            <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-y-[14px] tw:lg:gap-y-0 tw:gap-4">
              <div className="tw:lg:w-[200px] tw:flex tw:flex-col tw:gap-[3px]">
                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:leading-[1.2] ${typo12}`}>{t(`bookingDetail.bookingCancellation.meetAssistCancellationFee.arrival.${cancelRequestData?.meetAssistCancellationDesc?.arrival?.type}`)}</span>
                <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                  {`${meetAssistFee?.arrival?.toLocaleString()}${t("bookingDetail.bookingCancellation.jpy")}`}
                </div>
              </div>
              <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8] tw:block tw:lg:hidden" />
              <div className="tw:flex tw:flex-col tw:gap-[3px]">
                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:leading-[1.2] ${typo12}`}>{t(`bookingDetail.bookingCancellation.meetAssistCancellationRate.arrival.${cancelRequestData?.meetAssistCancellationDesc?.arrival?.type}`)}</span>
                <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                  {i18n.language === "jp" ? meetAssistDesc?.arrival?.jp : meetAssistDesc?.arrival?.en}
                </div>
              </div>
            </div>
          )
        }

        {
          (detectDowngradeMeetAssist().departure) && (
            <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-y-[14px] tw:lg:gap-y-0 tw:gap-4">
              <div className="tw:lg:w-[200px] tw:flex tw:flex-col tw:gap-[3px]">
                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:leading-[1.2] ${typo12}`}>{t(`bookingDetail.bookingCancellation.meetAssistCancellationFee.departure.${cancelRequestData?.meetAssistCancellationDesc?.departure?.type}`)}</span>
                <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                  {`${meetAssistFee?.departure?.toLocaleString()}${t("bookingDetail.bookingCancellation.jpy")}`}
                </div>
              </div>
              <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8] tw:block tw:lg:hidden" />
              <div className="tw:flex tw:flex-col tw:gap-[3px]">
                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:leading-[1.2] ${typo12}`}>{t(`bookingDetail.bookingCancellation.meetAssistCancellationRate.departure.${cancelRequestData?.meetAssistCancellationDesc?.departure?.type}`)}</span>
                <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                  {i18n.language === "jp" ? meetAssistDesc?.departure?.jp : meetAssistDesc?.departure?.en}
                </div>
              </div>
            </div>
          )
        }
        {
          (!deferredPayment && cancelRequestData?.cancellationPercent === 100) && (
            <>
              <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
              <div className="tw:flex tw:flex-col">
                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.bookingCancellation.noRefundNote")}</span>
              </div>
            </>
          )
        }
      </div>
    </div>
  );
};

export default BookingCancellation;